<div class="partner-typeahead">
  <input
    #htmlTypeaheadElement
    #instance="ngbTypeahead"
    type="text"
    name="partner"
    id="partner"
    class="w-100 form-control"
    container="body"
    data-cy="partner-input"
    [ngClass]="fieldSize()"
    [placeholder]="placeholder() | translate"
    [attr.aria-invalid]="control().invalid && control().touched ? true : null"
    [ngbTypeahead]="search"
    [resultTemplate]="partnerTemplate"
    [inputFormatter]="partnerFormatter"
    [editable]="true"
    [disabled]="disabled()"
    [(ngModel)]="partnerModel"
    (focus)="focus$.next($event.target.value)"
    (click)="click$.next($event.target.value)"
    (selectItem)="selectItem($event)"
  />
  @if (showRemoveButton() && control().value) {
    <button class="icon-btn-suffix icon-btn-sm" (click)="removeItem()">
      <i class="fa-light fa-xmark"></i>
    </button>
  }
</div>

<ng-template #partnerTemplate let-r="result" let-t="term">
  <ngb-highlight [result]="r.name" [term]="t" [title]="r.name"></ngb-highlight>
</ng-template>
